<main class="notfound-page">
  <section class="hero-section">
    <div class="container-xl">
      <div class="content-wrapper">
        <div class="icon-container">
          <svg class="broom-icon" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="46" y="10" width="8" height="55" rx="4" fill="var(--sami-pink)"/>
            <rect x="30" y="60" width="40" height="8" rx="4" fill="var(--sami-blue)"/>
            <path d="M30 68 C30 85, 45 85, 45 75 L35 68 Z" fill="var(--sami-dark)"/>
            <path d="M70 68 C70 85, 55 85, 55 75 L65 68 Z" fill="var(--sami-dark)"/>
            <line x1="38" y1="72" x2="36" y2="82" stroke="var(--sami-pink)" stroke-width="2" stroke-linecap="round"/>
            <line x1="46" y1="72" x2="46" y2="84" stroke="var(--sami-pink)" stroke-width="2" stroke-linecap="round"/>
            <line x1="54" y1="72" x2="56" y2="82" stroke="var(--sami-pink)" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>

        <h1 class="error-code">404</h1>
        
        <h2 class="title">Ops! Questa pagina è sparita</h2>
        
        <p class="message">
          Qui non vediamo nemmeno le briciole...<br>
          <span class="sub">La pagina che cerchi sembra essersi volatilizzata.</span>
        </p>

        <div class="brioche-divider">
          <span class="brioche">
            <svg viewBox="0 0 40 30" fill="none">
              <ellipse cx="20" cy="20" rx="18" ry="10" fill="#D4A574"/>
              <ellipse cx="20" cy="18" rx="16" ry="8" fill="#E8C49A"/>
              <ellipse cx="20" cy="16" rx="14" ry="6" fill="#F5DEB3"/>
              <circle cx="12" cy="18" r="2" fill="#D4A574"/>
              <circle cx="20" cy="17" r="2" fill="#D4A574"/>
              <circle cx="28" cy="18" r="2" fill="#D4A574"/>
            </svg>
          </span>
        </div>

        <p class="cleanup-tip">
          <i class="fa-solid fa-broom"></i>
          Mentre cercavi, abbiamo già pulito tutto qui. Torna alla home!
        </p>

        <button class="btn-sami btn-home" (click)="goHome()">
          <i class="fa-solid fa-home"></i>
          Torna alla Home
        </button>

        <div class="services-hint">
          <span class="hint-label">Oppure vai su:</span>
          <div class="hint-links">
            <a href="/" class="hint-link">Home</a>
            <a href="/preventivo" class="hint-link">Preventivo</a>
            <a href="/sanificazioni" class="hint-link">Servizi</a>
            <a href="/blog" class="hint-link">Blog</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="sparkles-bg">
    <div class="sparkle s1"></div>
    <div class="sparkle s2"></div>
    <div class="sparkle s3"></div>
    <div class="sparkle s4"></div>
    <div class="sparkle s5"></div>
  </div>
</main>
